// extracted by mini-css-extract-plugin
export default {"box_post":"SearchAddress_box_post__51b+x","active":"SearchAddress_active__Tg8JW","btn_close":"SearchAddress_btn_close__d7TY9"};